import { Box, styled } from '@mui/material';

import {
  IconContainerStyle,
  AnimatedLinkContainerStyle,
} from './AnimatedLink.types';

export const AnimatedLinkContainer = styled('a')(
  ({ elementShadow, background, secondary }: AnimatedLinkContainerStyle) => ({
    display: 'flex',
    flexDirection: 'row',
    borderRadius: '6px',

    cursor: 'pointer',
    textDecoration: 'none',

    '&:hover': {
      boxShadow: `0px 0px 10px 2px ${elementShadow}`,
    },

    '&:hover .linkIcon': {
      backgroundColor: secondary,
      color: background,
    },

    '&:hover .textBody': {
      width: '100%',
    },

    transition: 'box-shadow .3s linear',
  }),
);

export const IconContainer = styled(Box)(
  ({ secondary }: IconContainerStyle) => ({
    display: 'flex',

    border: `2px solid ${secondary}`,
    borderRadius: '6px',
    padding: '8px',

    color: secondary,
    transition: 'color .3s linear, background-color .3s linear',
  }),
);

export const TextContainer = styled(Box)(() => ({
  width: 0,
  margin: 'auto 0',
  boxSizing: 'border-box',
  whiteSpace: 'nowrap',

  display: 'flex',

  overflow: 'hidden',

  transition: 'width .3s linear',
}));

export const PaddingContainer = styled(Box)(() => ({
  padding: '0 48px 0 24px',

  display: 'flex',
}));
